import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { TrainingEvent } from '@training/models/training/training-event.model';
import { AppStoreKeys } from 'src/app/store/store-keys.module';

import {
  RememberTrainingEvent,
  RememberTrainingEvents,
  ResetTrainingEvents,
  UpdatePinnedEvents
} from './training-events-state.actions';

export class TrainingEventsStateModel {
  readonly trainingEvents: TrainingEvent[];
  readonly isLoadedSuccessfully: boolean;
  readonly isSMSNotificationSettingEnabled?: boolean;
  readonly isProfileSettingEnabled: boolean;
}

@State<TrainingEventsStateModel>({
  name: AppStoreKeys.TrainingEvents,
  defaults: {
    trainingEvents: [],
    isLoadedSuccessfully: false,
    isSMSNotificationSettingEnabled: false,
    isProfileSettingEnabled: false
  }
})

@Injectable()
export class TrainingEventsState {
  @Selector()
  public static getState(
    state: TrainingEventsStateModel
  ): TrainingEventsStateModel {
    return state;
  }

  @Selector()
  public static getTrainingEvents(
    state: TrainingEventsStateModel
  ): TrainingEvent[] {
    return state.trainingEvents;
  }

  @Action(RememberTrainingEvents)
  rememberTrainingEvents(
    context: StateContext<TrainingEventsStateModel>,
    action: RememberTrainingEvents
  ): void {
    context.patchState({
      trainingEvents: action.payload,
      isLoadedSuccessfully: action.isLoadedSuccessfully,
      isProfileSettingEnabled: action.isProfileSettingEnabled,
      isSMSNotificationSettingEnabled: action.isSMSNotificationSettingEnabled
    });
  }

  @Action(RememberTrainingEvent)
  rememberTrainingEvent(
    context: StateContext<TrainingEventsStateModel>,
    action: RememberTrainingEvent
  ): void {
    context.patchState({
      trainingEvents: [action.payload],
      isLoadedSuccessfully: action.isLoadedSuccessfully,
      isProfileSettingEnabled: action.isProfileSettingEnabled,
      isSMSNotificationSettingEnabled: action.isSMSNotificationSettingEnabled
    });
  }

  @Action(ResetTrainingEvents)
  resetTrainingEvents(context: StateContext<TrainingEventsStateModel>): void {
    context.setState({
      trainingEvents: [],
      isLoadedSuccessfully: false,
      isSMSNotificationSettingEnabled: false,
      isProfileSettingEnabled: false
    });
  }

  @Action(UpdatePinnedEvents)
  UpdatePinnedEvents(
    context: StateContext<TrainingEventsStateModel>,
    action: UpdatePinnedEvents
  ): void {
    context.patchState({
      trainingEvents: action.payload
    });
  }
}
